import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import WorkInfosEditionModal from './WorkInfosEditionModal.js'

import FaCalendar from 'react-icons/fa/calendar'
import FaMapMarker from 'react-icons/fa/map-marker'
import FaPencil from 'react-icons/fa/pencil'
import Modal from 'react-modal'

@autobind
class WorkInfos extends Component {
  constructor () {
    super()
    this.state = {
      showModal: false
    }
  }

  handleOpenModal (elem) {
    this.setState({showModal: true, edition: elem})
  }

  handleCloseModal () {
    this.setState({showModal: false})
  }

  componentWillMount () {
    Modal.setAppElement('body')
  }

  render () {
    var tags = this.props.tags && this.props.tags.map((tag, i) => <a href={'/search/' + tag} key={i}>{tag}</a>)
    const canEdit = this.props.policy && this.props.policy.can_edit

    return (
      <header className='workInfos'>
        <h1 className='workInfos__title'>{this.props.title}{canEdit && <small className='btn btn-link'><FaPencil onClick={() => this.handleOpenModal('title')} /></small>}</h1>
        <p className='workInfos__desc'>{this.props.description}{canEdit && <small className='btn btn-link'><FaPencil onClick={() => this.handleOpenModal('desc')} /></small>}</p>
        <Modal isOpen={this.state.showModal} contentLabel='Edit work informations' onRequestClose={this.handleCloseModal} overlayClassName='modal' className='modal-dialog'
        >
          <WorkInfosEditionModal onCloseModal={this.handleCloseModal} work={this.props} type={this.state.edition} />
        </Modal>
        <div className='workInfos__details'>
          {(this.props.tags && this.props.tags.length > 0) && <div className='workInfos__detail workInfos__detail__tags'>
            <div>
              {tags}
            </div>
          </div>}
          {canEdit && <small className='btn btn-link'><FaPencil onClick={() => this.handleOpenModal('tags')} /></small>}
          <div className='workInfos__detail'>
            {this.props.created_at && <div>
              <time dateTime={this.props.created_at}>{(new Date(this.props.created_at)).toDateString()}</time>
            </div>}
          </div>
        </div>
      </header>
    )
  }
}

export default WorkInfos

WorkInfos.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  created_at: PropTypes.string,
  tags: PropTypes.array,
  can_rotate: PropTypes.bool,
  school: PropTypes.object
}



// WEBPACK FOOTER //
// ./components/work/WorkInfos.js